import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  copy() {
    const codes = Array.from(this.element.querySelectorAll("div.bg-black-50"))
      .map(el => el.textContent.trim())
      .join(" ");

    navigator.clipboard.writeText(codes).then(() => {
      alert("Backup codes copied!");
    }).catch(() => {
      alert("Failed to copy backup codes.");
    });
  }
}
